import { createFileRoute } from "@tanstack/react-router";
import UKCheapCars from "@/pages/landing/UKCheapCars";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/cheap-cars-under-5000/")({
  head: () => routeHead("/uk/cheap-cars-under-5000/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <UKCheapCars />
  );
}
